import { render } from "./InputTypeInputGroup.vue?vue&type=template&id=1b6def12"
import script from "./InputTypeInputGroup.vue?vue&type=script&lang=js"
export * from "./InputTypeInputGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__